import { Pipe, PipeTransform } from '@angular/core';
import {Product} from '../../pages/model/types'
/**
 * Generated class for the ProductfilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'productfilter',
  pure: false
})
export class ProductfilterPipe implements PipeTransform {
  transform(items: Product[], filter: string): any {
    if (filter=="") {
        return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => item.ProductName.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/productfilter/productfilter.ts